<template>
  <div>
    <div style="display:flex;">
      <div>
        <el-input
          style="width:200px;margin-right:10px"
          v-model="search"
          size="large"
          placeholder="订单号搜索"
        />
        <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
          <el-option v-for="n in travelStatus" :key="n.key" :label="n.label" :value="n.value"></el-option>
        </el-select>
      </div>
      <el-button style="margin-left:20px" type="primary" @click="getExcle">导出发货表格</el-button>
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData.filter(data => !search || data.orderSn.toLowerCase().includes(search.toLowerCase()))"
      style="width: 100%"
    >
      <el-table-column label="订单号" prop="orderSn"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatTimer }}</template>
      </el-table-column>
      <el-table-column label="买家名称" prop="receiverName"></el-table-column>
      <el-table-column label="付款时间">
        <template slot-scope="scope">{{ scope.row.paymentTime | formatTimer }}</template>
      </el-table-column>
      <el-table-column label="实付金额">
        <template
          slot-scope="scope"
        >{{ scope.row.discountAmount==null?scope.row.payAmount:scope.row.discountAmount }}</template>
      </el-table-column>
      <el-table-column label="支付方式" prop="payType">
        <template
          slot-scope="scope"
        >{{ scope.row.payType===3?'对公转账':(scope.row.payType===1?'支付宝':(scope.row.payType===2?'微信':''))}}</template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">{{ scope.row.status | statusTimer }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
          <el-button
            v-if="scope.row.status===1"
            size="mini"
            type="warning"
            @click="handleSendGoods(scope.$index, scope.row)"
          >发货</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看订单dialog -->
    <div>
      <el-dialog title="订单详情" :visible.sync="detaildialogVisible" width="30%">
        <el-button style="margin-bottom:20px" @click="oneWordCopy(copyText)">一键复制发货信息</el-button>
        <!-- 下单人信息 -->
        <el-descriptions class="margin-top" title :column="1" border>
          <el-descriptions-item>
            <template slot="label">订单号</template>
            {{detailData.orderSn}}
          </el-descriptions-item>
          <!-- <el-descriptions-item>
            <template slot="label">实付金额</template>
            {{ detailData.discountAmount == null ? detailData.payAmount:detailData.discountAmount }}
          </el-descriptions-item>-->
          <el-descriptions-item>
            <template slot="label">联系人</template>
            {{detailData.receiverName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系方式</template>
            {{detailData.receiverPhone}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">联系地址</template>
            {{detailData.receiverProvince+detailData.receiverCity+detailData.receiverRegion+detailData.receiverDetailAddress}}
          </el-descriptions-item>
        </el-descriptions>
        <!-- 商品 -->

        <div style="margin-top:10px" v-for="n in detailData.omsOrderItems" :key="n.key">
          <el-descriptions class="margin-top" title :column="1" border>
            <el-descriptions-item>
              <template slot="label">店铺</template>
              {{n.storeName}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">商品图片</template>
              <el-image style="width: 100px; height: 100px" :src="n.productPic"></el-image>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">商品</template>
              {{n.productName}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">规格</template>
              {{n.sp1+"（"+n.sp2+"）"}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">数量</template>
              {{n.productQuantity}}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 快递部分 -->
        <div v-if="isShowExpress" style="margin-top:10px">
          <el-descriptions class="margin-top" title :column="1" border>
            <el-descriptions-item>
              <template slot="label">物流公司</template>
              {{detailData.deliveryCompany}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">物流单号</template>
              {{detailData.deliverySn}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">物流信息</template>
              <div>
                <el-steps direction="vertical" :active="1">
                  <el-step
                    v-for="n in wuliuArr"
                    :key="n.key"
                    :title="n.context"
                    :description="n.time"
                  ></el-step>
                </el-steps>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 发货 -->
    <div>
      <el-dialog
        title="发货"
        :visible.sync="sendGoodsdialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <!-- 发货需要的数据 -->
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
          <el-form-item label="物流公司">
            <el-select
              value-key="id"
              v-model="value"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="getExpress"
              :loading="loading"
            >
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="物流单号" prop="expressNo">
            <el-input v-model="ruleForm.expressNo"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendGoodsdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSendExpress">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryStatus, queryOrderDetails, queryExpress, upDateOrderStatus, getexcel, queryWuLiu } from '../../api'
export default {
  data () {
    return {
      copyText: '',
      isShowExpress: false,
      //表单
      ruleForm: {
        // 物流单号
        expressNo: '',
      },
      options: [],
      loading: false,
      value: [],
      detailData: [],
      // 订单详情dialog
      detaildialogVisible: false,
      sendGoodsdialogVisible: false,
      paras: {
        status: 1,
      },
      travelStatus: [ //  状态列表
        {
          value: 0,
          label: '待付款'
        },
        {
          value: 1,
          label: '待发货'
        },
        {
          value: 2,
          label: '已发货'
        },
        {
          value: 3,
          label: '已完成'
        }
      ],
      search: '',
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      status: 1,
      deleteStatus: 0,
      tableData: [],
      orderId: 0,
      // 物流数据
      wuliuArr: []
    }
  },
  filters: {
    statusTimer: function (value) {
      switch (value) {
        case 0:
          return "待付款"
          break;
        case 1:
          return "待发货"
          break;
        case 2:
          return "已发货"
          break;
        case 3:
          return "已完成"
          break;
        default:
          break
      }
    },
    formatTimer: function (value) {
      if (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      } else {
        return "/"
      }

    }
  },
  mounted () {
    // 查询订单列表
    this.getOrderList()
  },
  methods: {

    //导发货表
    getExcle () {
      let para = new URLSearchParams()
      let responseType = {
        responseType: 'blob'
      }
      getexcel(para, responseType).then(res => {
        if (res > 2) {
          this.$message.error('请求失败')
        } else {
          console.log(res)
          // type 为需要导出的文件类型，此处为xls表格类型
          const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob)
          // 创建a标签并为其添加属性
          let downloadLink = document.createElement('a')
          downloadLink.href = downloadHref
          downloadLink.download = '待发货列表.xlsx'
          // 触发点击事件执行下载
          downloadLink.click()
        }
      })
    }
    ,
    oneWordCopy (shareLink) {
      if (shareLink) {
        var textarea = document.createElement("textarea");   // 直接构建input
        textarea.value = shareLink;  // 设置内容
        document.body.appendChild(textarea);    // 添加临时实例
        textarea.select();   // 选择实例内容
        document.execCommand("Copy");   // 执行复制
        document.body.removeChild(textarea); // 删除临时实例
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } else {
        this.$message.error('复制失败');
      }
    },
    // 实时监听物流公司
    searchExpress (e) {
      console.log(e);
      // like 查询物流公司
      this.getExpress(e)
    },
    // like查询物流公司
    getExpress (query) {
      if (query !== '') {
        this.loading = true;
        let para = new URLSearchParams()
        para.append('name', name)
        queryExpress(para).then(data => {
          console.log(data);
          this.loading = false
          this.options = data.data
        })
      } else {
        this.options = [];
      }
    },
    // 提交物流信息
    handleSendExpress () {
      let para = new URLSearchParams()
      para.append('orderId', this.orderId)
      para.append('expressNo', this.ruleForm.expressNo)
      para.append('expressId', this.value.id)
      upDateOrderStatus(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.sendGoodsdialogVisible = false
          this.getOrderList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 订单详情接口
    queryOrderDetail (orderId) {
      let para = new URLSearchParams()
      para.append('orderId', orderId)
      queryOrderDetails(para).then(data => {
        console.log("111", data);
        if (data.code === 10000) {
          this.detailData = data.data
          let contactText = "联系人：" + data.data.receiverName + "\n联系方式：" + data.data.receiverPhone + "\n联系人地址："
            + data.data.receiverProvince + data.data.receiverCity + data.data.receiverRegion + data.data.receiverDetailAddress
          // 商品信息
          let shopArr = data.data.omsOrderItems
          let shopText = ''
          for (let i = 0; i < shopArr.length; i++) {
            shopText += "\n商品名：" + shopArr[i].productName + "\n规格：" + shopArr[i].sp1 + "（" + shopArr[i].sp2 + "）" + "\n商品数量：" + shopArr[i].productQuantity
          }
          this.copyText = contactText + shopText

          if (data.data.deliverySn) {
            this.isShowExpress = true
            // 处理手机号
            let phone = data.data.receiverPhone + ''
            let lastPhone = phone.substr(-4)
            //查询物流公司
            this.getOrderExpressCompany(data.data.deliverySn, lastPhone)
            // this.getOrderExpressCompany('773211755176548', '9518')
          } else {
            this.isShowExpress = false
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 查询物流公司
    getOrderExpressCompany (deliverySn, lastPhone) {
      let para = new URLSearchParams()
      para.append('number', deliverySn)
      para.append('phone', lastPhone)
      queryWuLiu(para).then(data => {
        console.log(data);
        // console.log(data);
        if (data.code === 10000) {
          console.log(data);
          const wuLiuMsg = JSON.parse(data.data)
          if (wuLiuMsg.showapi_res_code === 0) {
            this.wuliuArr = wuLiuMsg.showapi_res_body.data
          } else {
            this.$message({
              message: wuLiuMsg.showapi_res_error,
              type: 'error'
            })
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
   
    //查看订单详情
    handleDetail (index, item) {
      // 1打开dialog
      console.log(index, item);
      this.detaildialogVisible = true
      this.queryOrderDetail(item.id)
    },
    // 参数含义 index :索引  item 对象
    // 发货
    handleSendGoods (index, item) {
      this.sendGoodsdialogVisible = true
      this.orderId = item.id
      this.ruleForm.expressNo = ''
      this.value = []
    },
    //筛选
    handleSearch (index) {
      console.log(index);
      this.status = index
      this.currentpageIndex = 1
      this.getOrderList()
    },
    getOrderList () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      para.append('status', this.status)
      para.append('deleteStatus', this.deleteStatus)
      queryStatus(para).then(data => {
        console.log(data);
        // console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.getOrderList()
    },
  },

}
</script>


<style lang="stylus" scoped>
#profit {
  .prohead {
    display: flex;
    justify-content: space-between;

    .el-form-item {
      display: flex;
    }
  }

  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .flexright {
    display: flex;
    justify-content: flex-end;
  }
}
</style>

